import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import utils from 'src/utils';
import uiDux from 'src/redux/ui/';
import appDux from 'src/redux/app/';
import MenuItem from './MenuItem';
import { PaintItemContainer, VariationGroup, Divider } from './styled';

const { showInDesignExtendedSidebar } = utils.designSidebar;

const mapStateToProps = (state) => ({
  variationGroups: appDux.selectors.getActiveVariationGroups(state),
  activeGroupIndex: appDux.selectors.getActiveVariationGroupIndex(state),
  activeEditingAttributePropertyId: appDux.selectors.getActiveEditingAttributePropertyId(
    state,
  ),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleAttributeSelectionClick:
        uiDux.actions.handleAttributeSelectionClick,
    },
    dispatch,
  );

export class VariationGroupSelector extends PureComponent {
  static propTypes = {
    variationGroups: PropTypes.object.isRequired,
    activeGroupIndex: PropTypes.number.isRequired,
    activeEditingAttributePropertyId: PropTypes.number.isRequired,
    handleAttributeSelectionClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const { activeGroupIndex } = props;
    this.state = { activeGroupIndex };
  }

  componentDidUpdate(prevProps) {
    const { activeGroupIndex } = this.props;
    if (activeGroupIndex !== prevProps.activeGroupIndex) {
      this.setState({ activeGroupIndex });
    }
  }

  @autobind
  handleVariationClick(activeGroupIndex) {
    this.setState({ activeGroupIndex });
  }

  @autobind
  renderVariationGroups() {
    const { variationGroups } = this.props;
    const { activeGroupIndex } = this.state;

    if (!(variationGroups.length > 0)) return null;

    return (
      <div>
        {variationGroups.map(({ name, id }, index) => (
          <VariationGroup
            key={id}
            isSelected={index === activeGroupIndex}
            onClick={() => this.handleVariationClick(index)}
          >
            {name}
          </VariationGroup>
        ))}
        <Divider />
      </div>
    );
  }

  render() {
    const {
      handleAttributeSelectionClick,
      activeEditingAttributePropertyId,
      variationGroups,
    } = this.props;
    const { activeGroupIndex } = this.state;
    const { children } = variationGroups[activeGroupIndex];

    return (
      <div>
        {this.renderVariationGroups()}
        <PaintItemContainer>
          {!!children.length &&
            children.map((item) => (
              <MenuItem
                key={item.id}
                {...item}
                isSelected={activeEditingAttributePropertyId === item.id}
                handleClick={() => handleAttributeSelectionClick(item)}
              />
            ))}
        </PaintItemContainer>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VariationGroupSelector);
